/* ------------------------------------------------------------------------
   Colour swatches: hovering a swatch shows its colour name next to "Colour";
   leaving puts the current colour back. While the feature is in preview the
   row is only shown when the address ends in ?swatches=1.
   ------------------------------------------------------------------------ */
(function () {
	var root = document.querySelector('[data-kc-colorlinks]');
	if (!root) return;

	if (root.hasAttribute('data-kc-preview')) {
		if (/[?&]swatches=1(&|$)/.test(window.location.search)) {
			root.hidden = false;
		} else {
			return;
		}
	}

	var name = root.querySelector('[data-kc-colorlinks-name]');
	if (!name) return;
	var fallback = name.getAttribute('data-default') || name.textContent;

	root.querySelectorAll('[data-kc-colorlink]').forEach(function (link) {
		function show() { name.textContent = link.getAttribute('data-label'); }
		function reset() { name.textContent = fallback; }
		link.addEventListener('mouseenter', show);
		link.addEventListener('focus', show);
		link.addEventListener('mouseleave', reset);
		link.addEventListener('blur', reset);
	});
})();
